import { ColumnConfig, ProductCFATabTabelKey } from '../../model';

export const productCFATabConfig: Record<ProductCFATabTabelKey, ColumnConfig> =
  {
    cfaWithImage: {
      name: 'CFA',
      field: 'component',
      alignment: 'flex-start',
    },
    moq: { name: 'MOQ', alignment: 'flex-start' },
    stock: { name: 'Stock', alignment: 'flex-start' },
    action: { name: '', alignment: 'flex-start' },
  };
